module.exports = __webpack_public_path__ + "assets/img/homeButton.0bb2e5b0.png";